import React, { useState, Fragment } from 'react';
import { ModalButton } from './ModalButton';
import { ModalMail } from './ModalMail';
import { ISendDocumentation } from './types';

export const SendDocumentation = ({ lead, vehicle, ...props }: ISendDocumentation) => {
    const [open, setOpen] = useState<boolean>(false);

    return (
        <Fragment>
            <ModalButton lead={lead} setOpen={setOpen} {...props} />
            {open && <ModalMail lead={lead} vehicle={vehicle} setOpen={setOpen} />}
        </Fragment>
    );
};
